import { Link } from "react-router-dom";
import styles from "./BlogCard.module.css";

export default function BlogCard({ blog }) {
  if (!blog) {
    return null;
  }

  const image = blog.image || blog.image_url || "";

  return (
    <Link to={`/blog/${blog.slug}`} className={styles.card} aria-label={blog.title}>
      <div className={styles.content}>
        <div className={styles.imageWrap}>
          {image ? (
            <img src={image} alt={blog.title} className={styles.image} loading="lazy" decoding="async" />
          ) : (
            <div className={styles.placeholder}>PSP RCM</div>
          )}
        </div>
        <h3 className={styles.title}>
          {blog.title}
        </h3>
        {/* Date removed from blog card */}
        <p className={styles.description}>{blog.excerpt}</p>
      </div>
    </Link>
  );
}
